import { render } from "./UserRoot.vue?vue&type=template&id=5064a5c8"
import script from "./UserRoot.vue?vue&type=script&lang=js"
export * from "./UserRoot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__